import {
  convertYesNo,
  getValidDate,
} from '../../../common/commonUtils/commonUtils';

export const historyOfConvictionslabel = 'History Of Convictions';

export const leftHeadings = [
  'SAP PARTICIPANT PRIFOLE - PART B',
  'CENTRAL FILE REVIEW',
];

export const getParticipantFields = ({
  CDCNumber,
  participantName,
  dateReceivedCDC,
  lengthOfTermInYrsAndMos,
  secondStrike,
}) => [
  { xs: 4, label: 'CDC Number', value: CDCNumber },
  { xs: 4, label: 'Participant Name(Last, First)', value: participantName },
  { xs: 4, label: 'DOB', value: '' },
  { xs: 4, label: 'Date Recieved CDC', value: getValidDate(dateReceivedCDC) },
  { xs: 4, label: 'Length of Term (Y/Mo)', value: lengthOfTermInYrsAndMos },
  { xs: 4, label: '2 nd strike ?', value: convertYesNo(secondStrike) },
];

export const getReleaseAndControlingDate = ({
  releaseDate,
  controllingDischargeDate,
  highControlSupervision,
}) => [
  { xs: 4, label: 'Release Date', value: getValidDate(releaseDate) },
  {
    xs: 4,
    label: 'Controlling Discharge Date',
    value: getValidDate(controllingDischargeDate),
  },
  {
    xs: 4,
    label: 'High Control Supervision',
    value: convertYesNo(highControlSupervision),
  },
];

export const getReleaseFields = ({ EPRD, RRD, PED, CDD, CDD_MAX }) => [
  { label: 'EPRD', checked: EPRD },
  { label: 'RRD', checked: RRD },
  { label: 'PED', checked: PED },
  { label: 'CDD', checked: CDD },
  { label: 'CDD/MAX', checked: CDD_MAX },
];

export const getRegistrationAndParoleFields = ({
  h11590NarcoticRegistration,
  p290SexRegistration,
  p457_1ArsonRegistration,
  pC296ViolentOrSeriousOffenderNotification,
  countyOfLastLegalResidenceValue,
  city,
  paroleRegion,
}) => [
  {
    xs: 4,
    label: 'H111590 Narcotic Registration',
    value: convertYesNo(h11590NarcoticRegistration),
  },
  {
    xs: 4,
    label: 'P290 Sex Registration',
    value: convertYesNo(p290SexRegistration),
  },
  {
    xs: 4,
    label: 'P457.1 Arson Registration',
    value: convertYesNo(p457_1ArsonRegistration),
  },
  {
    xs: 4,
    label: 'PC 296 Violent/Serious Offender Notification',
    value: convertYesNo(pC296ViolentOrSeriousOffenderNotification),
  },
  {
    xs: 4,
    label: 'County of Last Legal Residence(CLLR)',
    value: countyOfLastLegalResidenceValue,
  },
  { xs: 4, label: 'City', value: city },
  { xs: 4, label: 'Parole Region', value: paroleRegion },
];

export const rSuffixFields = ({ rSuffixInCentralFile, rSuffixExplination }) => [
  {
    xs: 4,
    label: `'R' Suffix in Central File`,
    value: convertYesNo(rSuffixInCentralFile),
  },
  {
    xs: 4,
    label: `If Yes, explain`,
    value: rSuffixExplination,
  },
];

export const getGangInfoCheckBox = () => [{ label: 'Clear', checked: false }];

export const getEnemiesCheckBox = () => [
  { label: 'Clear', checked: false },
  { label: 'Noticed(see CDC 812)', checked: false },
];

export const getInstitutionalCheckBox = () => [
  { label: `115's Clear`, checked: false },
  { label: `128's Clear`, checked: false },
];

export const getAdaFields = ({ ADA }) => [
  { xs: 12, content: 'ADA or DDP Concerns' },
  { xs: 2, content: convertYesNo(ADA) },
  { xs: 10, content: `Comments: ` },
];

export const getVeteranCheckBox = () => [{ label: 'Unknown', checked: false }];
export const getReadingLevelCheckBox = () => [
  { label: 'Unknown', checked: false },
];

export const getCccmsData = () => [
  { xs: 2, label: 'CCCMS', value: '' },
  { xs: 2, label: 'Psych Meds', value: '' },
  { xs: 4, label: 'Comments', value: '' },
  { xs: 2, label: 'Date of TB Test', value: '' },
  { xs: 2, label: 'Code', value: '' },
];

export const getParoleViolationCheckBox = () => [
  { label: 'Not Applicable', checked: false },
];

export const getNoContactRowData = () => [
  { xs: 2, label: 'No Contact', value: '' },
  { xs: 10, label: 'Explain(Who, where, etc.)', value: '' },
];

export const getWarrantRowData = () => [
  { xs: 3, label: 'Active Detaheror Warrants in C-File', value: '' },
  { xs: 5, label: 'Warrant Agency, Number, Changes, Ball, Etc.', value: '' },
  { xs: 2, label: 'Restraining Order In C-File', value: '' },
  { xs: 2, label: 'Expiration Date', value: '' },
];

export const getReleaseTypeData = ({ releaseTypeData }) => [
  { xs: 4, label: 'Release Type', items: releaseTypeData },
];

export const getGangEnemyDisciplinData = ({
  enemies,
  gangInfoData,
  gangEnemiesData,
  institutionalData,
}) => [
  { xs: 8, label: 'Gang Information/Monker', items: gangInfoData },
  { xs: 4, label: `Enemies: ${convertYesNo(enemies)}`, items: gangEnemiesData },
  {
    xs: 12,
    label: 'Institutional Disciplinary History',
    items: institutionalData,
  },
];

export const getParoleViolationData = ({ paroleViolationCB }) => [
  {
    xs: 12,
    label: 'Parole Violation Charges-Good Cause Findings',
    items: paroleViolationCB,
  },
];
